import React from 'react'
import { __ } from '../services/translate'
import { FlexRow } from './Common/Layout'
import { Button, ButtonNeutral } from './Common/Button'
import Modal from './Common/Modal'

const redirectToLicenceUrl = () => window.open('https://www.blutacho.com', '_blank')

export default ({ onClose }) => {
  return (
    <Modal onClose={onClose}>
      <h4>{__('Litujeme, ale tento modul nemáte předplacený')}</h4>
      <FlexRow>
        <ButtonNeutral onClick={onClose}>{__('Zavřít')}</ButtonNeutral> &nbsp;
        <Button onClick={redirectToLicenceUrl}>{__('Získat licenci')}</Button>
      </FlexRow>
    </Modal>
  )
}